import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';

const organizationName = (state) => {
    if (state === undefined) {
        return {};
    }
    return state;
};

export default combineReducers({
    routing,
    form,
    organizationName,
});
